export function restFildSet(fieldset) {
  const inputs = fieldset.querySelectorAll('input, select, textarea');
  inputs.forEach((input) => {
    switch (input.type) {
      case 'checkbox':
      case 'radio':
        input.checked = input.defaultChecked;
        break;
      case 'select-one':
      case 'select-multiple':
        Array.from(input.options).forEach((option) => {
          option.selected = option.defaultSelected;
        });
        break;
      default:
        input.value = input.defaultValue;
        break;
    }
  });
}

export function _validateForm(element) {
  const closestForm = element.closest('form');
  if (!closestForm) return true;

  const activeInputs = Array.from(closestForm.querySelectorAll('input, select, textarea')).filter((input) => !input.disabled && !input.readOnly);

  for (let input of activeInputs) {
    if (!input.checkValidity()) {
      input.reportValidity();
      return false;
    }
  }
  return true;
}

export function isParentFieldsetDisabled(element) {
  let parent = element.parentElement;
  while (parent) {
    if (parent.tagName === 'FIELDSET' && parent.disabled) {
      return true;
    }
    parent = parent.parentElement;
  }
  return false;
}
